'use strict';

angular.module('amexReconciliationApp')
  .component('transactionNavigation', {
    templateUrl: 'scripts/views/components/transaction-navigation.html',
    controller: function ($state,
                          $stateParams,
                          $q,
                          TransactionPaginationService,
                          TransactionFilterModel) {
      var self = this;

      self.transactionIndex = parseInt($stateParams.index);
      self.transactionsSize = TransactionFilterModel.transactions().length;


      self.backToTransactionsList = function () {
        $state.go('transactions');
      };

      self.nextTransaction = function nextTransaction() {
        goToIndex(self.transactionIndex + 1);
      };

      self.previousTransaction = function previousTransaction() {
        goToIndex(self.transactionIndex - 1);
      };

      self.thereIsANextTransaction = function thereIsANextTransaction() {
        return self.transactionIndex < TransactionPaginationService.totalCount();
      };

      self.thereIsAPreviousTransaction = function thereIsAPreviousTransaction() {
        return self.transactionIndex > 1;
      };

      function goToIndex(newIndex) {
        getTransactionFor(newIndex)
          .then(function (transaction) {
            $state.go($state.current.name, {index: newIndex, transactionId: transaction.id});
          });
      }

      function getTransactionFor(index) {
        return getPageOfTransactionsFor(index).then(getTransactionAtIndex);

        function getTransactionAtIndex(transactions) {
          return transactions[index - TransactionPaginationService.pageStart()];
        }
      }

      function getPageOfTransactionsFor(index) {
        if (index > TransactionPaginationService.pageEnd()) {
          TransactionPaginationService.nextPage();
        } else if (index < TransactionPaginationService.pageStart()) {
          TransactionPaginationService.previousPage();
        }

        return $q.when(TransactionPaginationService.recordsOnCurrentPage());
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionNavigation.js
// module id = 495
// module chunks = 0